import type { Point } from '@/types';
import { VERIFIED_BROADHEADS } from './broadheads-verified';

const FIELD_POINTS: Point[] = [
  { name: 'Field Point 75 gr', weight: 75, category: 'field' },
  { name: 'Field Point 85 gr', weight: 85, category: 'field' },
  { name: 'Field Point 100 gr', weight: 100, category: 'field' },
  { name: 'Field Point 125 gr', weight: 125, category: 'field' },
  { name: 'Field Point 150 gr', weight: 150, category: 'field' },
  { name: 'Field Point 175 gr', weight: 175, category: 'field' },
  { name: 'Field Point 200 gr', weight: 200, category: 'field' },
  // ─── 2026-06-07 audit gap-fill — heavy field points + small-game ───
  { name: 'Field Point 250 gr', weight: 250, category: 'field' },
  { name: 'Field Point 300 gr', weight: 300, category: 'field' },
  { name: 'Zwickey Judo Point 125gr', weight: 125, category: 'field' },
  { name: 'G5 Small Game Head 100gr', weight: 100, category: 'field' },
];

/**
 * Combined POINTS catalog. Field points + 100+ verified broadheads from
 * 14 brands (Bowmar, NAP, Evolution, SEVR, Rage, G5, Grim Reaper, Firenock,
 * Iron Will, Annihilator, Magnus, Slick Trick, Day Six, Tooth of the Arrow)
 * with Yates 2025 drag tier where tested.
 */
export const POINTS: readonly Point[] = [
  ...FIELD_POINTS,
  ...VERIFIED_BROADHEADS,
];
